<template>
  <div>
    <router-link :to="'post/' + post.slug">
      <div>
        <div :class="`home-image-place each-post ${post.category_name}`" :data-id="`${post.id}`">
          <div class="home-image bannerAnimation" :style="{ backgroundImage: `url('${post.thumbnail}')` }">
          </div>

          <p v-if="displaySettings.showTitles" class="countAnimation post-count">{{ this.romanize(this.posts.length -
            this.index) }}</p>
          <transition name="post-details" appear>
            <div v-if="displaySettings.showTitles" class="post-details latest-post-slide">
              <h2 class="post-title">{{ post.title }}</h2>
              <p class="post-description">{{ post.description }}</p>
              <p class="post-date">{{ post.date }}</p>
            </div>
          </transition>
        </div>
      </div>
    </router-link>
  </div>

</template>

<script>
export default {
  name: "FullScreenPost",
  props: ['post', 'index', 'posts', 'displaySettings'],
  data: function () {
    return {
      hoverDetails: false,
      computedHeight: 'auto',
      showDetails: false,
    }
  },
  computed: {
    postDescriptionHeight() {
      if (this.hoverDetails) {
        return { height: `${this.computedHeight}px` }
      } else {
        return { height: 0 }
      }
    },
  },
  methods: {
    romanize: function (num) {
      const romanMap = [
        { value: 1000, numeral: 'M' },
        { value: 900, numeral: 'CM' },
        { value: 500, numeral: 'D' },
        { value: 400, numeral: 'CD' },
        { value: 100, numeral: 'C' },
        { value: 90, numeral: 'XC' },
        { value: 50, numeral: 'L' },
        { value: 40, numeral: 'XL' },
        { value: 10, numeral: 'X' },
        { value: 9, numeral: 'IX' },
        { value: 5, numeral: 'V' },
        { value: 4, numeral: 'IV' },
        { value: 1, numeral: 'I' }
      ];

      let roman = '';
      romanMap.forEach(({ value, numeral }) => {
        while (num >= value) {
          roman += numeral;
          num -= value;
        }
      });
      return roman;
    },
    getTopColorsFromImage: function (imgElement, topN = 4) {
      const colorDistanceThreshold = 100
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = imgElement.width;
      canvas.height = imgElement.height;
      ctx.drawImage(imgElement, 0, 0);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imageData.data;
      const colorMap = new Map();

      function quantize(r, g, b) {
        const qr = Math.round(r / 32) * 32;
        const qg = Math.round(g / 32) * 32;
        const qb = Math.round(b / 32) * 32;
        return `${qr},${qg},${qb}`;
      }

      function colorDistance(rgb1, rgb2) {
        const [r1, g1, b1] = rgb1;
        const [r2, g2, b2] = rgb2;
        return Math.sqrt((r1 - r2) ** 2 + (g1 - g2) ** 2 + (b1 - b2) ** 2);
      }

      for (let i = 0; i < pixels.length; i += 4) {
        const r = pixels[i], g = pixels[i + 1], b = pixels[i + 2], a = pixels[i + 3];
        if (a < 128) continue;
        const key = quantize(r, g, b);
        colorMap.set(key, (colorMap.get(key) || 0) + 1);
      }

      const sortedColors = [...colorMap.entries()]
        .sort((a, b) => b[1] - a[1]) // sort by frequency
        .map(([key]) => key.split(',').map(Number)); // convert to [r,g,b]

      const result = [];

      for (const rgb of sortedColors) {
        if (result.length === 0) {
          result.push(rgb);
        } else {
          const isDistinct = result.every(existing => colorDistance(existing, rgb) > colorDistanceThreshold);
          if (isDistinct) result.push(rgb);
        }

        if (result.length >= topN) break;
      }

      return result.map(([r, g, b]) => `rgb(${r},${g},${b})`);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../stylesheets/base/variables";

a:link,
a:active,
a:visited,
a:hover {
  text-decoration: none;
}

.post-count {
  position: absolute;
  top: 30px;
  right: 60px;
  text-decoration: none;
  font-size: 60px;
  font-weight: lighter;
  text-align: left;
  color: white;
  margin: 0;
  opacity: 0;

  @media screen and (max-width: 1400px) {
    display: none;
  }
}

@keyframes countEnter {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.countAnimation {
  animation: countEnter 4s ease-in;
  animation-delay: 0.6s;
  animation-fill-mode: forwards;
}

.home-image-place {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #161616;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: black;

  @media screen and (max-width: 768px) {
    height: 40vh;
  }
}

.shadow {
  border: 50px #ffcc00 !important;
  /* Adjust color and width as needed */
}

.home-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-color: black;
}

.post-details {
  position: absolute;
  top: 54vh;
  left: 5vw;
  background-color: rgba(16, 16, 16, 0.1);
  width: 80vw;
  padding: 20px 80px;

  &.right {
    left: auto;
    right: 5vw;
    text-align: right !important;
  }

  .post-title {
    font-size: 80px;
    color: white;
    margin-bottom: 10px;

    &.right {
      text-align: right !important;
    }
  }

  .post-description {
    font-size: 24px;
    font-weight: lighter;
    color: white;
    margin: 0;
    margin-bottom: 12px;

    &.right {
      text-align: right !important;
    }
  }

  .post-date {
    font-size: 20px;
    font-weight: lighter;
    color: white;
    margin: 0;

    &.right {
      text-align: right !important;
    }
  }
}

@media screen and (max-width: 1400px) {
  .post-details {
    top: 60vh;
    left: 5vw;
    width: 80vw;
    padding: 20px;

    .post-title {
      font-size: 46px;
    }

    .post-description {
      font-size: 24px;
    }
  }
}

@media screen and (max-width: 768px) {
  .post-details {
    top: 52vh;
    left: 0;
    bottom: 0;
    width: 100vw;
    padding: 40px;
    height: 50vh;

    .post-title {
      font-size: 30px;
    }

    .post-description {
      font-size: 14px;
    }
  }
}

@keyframes bannerEnter {
  0% {
    opacity: 0;
    transform: scale(1);
  }

  100% {
    opacity: 1;
    transform: scale(1.08);
  }
}

@keyframes bannerBlur {
  0% {
    filter: blur(10px);
  }

  100% {
    filter: blur(0px);
  }
}

.bannerAnimation {
  animation: bannerEnter 8s ease-out, bannerBlur 1.2s ease-out;
  transform: scale(1.08);
}

.post-details-enter-active {
  animation: slideInFromRight 8s cubic-bezier(0.22, 1, 0.36, 1);
  animation-delay: 0.0s;
  /* Start sliding after 1 second */
  animation-fill-mode: both;
  /* Keep the final position after animation ends */
}

.post-details-enter {
  transform: translateX(100px);
  opacity: 0;
}

@keyframes slideInFromRight {
  0% {
    transform: translateX(20px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

* {
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  background-color: #021027;
}

.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.background {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;

  mask-image: radial-gradient(white 0%,
      white 30%,
      transparent 80%,
      transparent);
}

.message {
  position: absolute;
  right: 20px;
  bottom: 10px;
  color: white;
  font-family: "Josefin Slab", serif;
  line-height: 27px;
  font-size: 18px;
  text-align: right;
  pointer-events: none;
  animation: message-frames 1.5s ease 5s forwards;
  opacity: 0;

  @keyframes message-frames {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
}

</style>
